import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';


import Header from '../../components/Header';
import Footer from '../../components/Footer';
import InsideHeader from '../../components/InsideHeader';
import PageIntroBanner from '../../components/PageIntroBanner';
import MenuAbout from '../../components/MenuAbout';
import CtaBanner from '../../components/CtaBanner';

function Testimonials({ page, widget }) {
  return (
    <div>
      <InsideHeader h1="Homeowner Testimonials" background={get(page, 'page_image.contentUrl')} />
      <PageHelmet page={page} />
      <Header />
      <MenuAbout />
      <PageIntroBanner
        h2={get(page, 'intro_banner[0].top_headline')}
        h3={get(page, 'intro_banner[0].main_headline')}
        h4={get(page, 'intro_banner[0].sub_headline')}
        p={get(page, 'intro_banner[0].paragraph')}
        background={get(page, 'intro_banner[0].photo.contentUrl')}
      />
      <div className="container">
        <div className="row">
          <ul className="testimonials">
            {
              get(widget, 'testimonials', []).map(testimonial => (
                <li key={testimonial.message}>
                  <div className="inner">
                    {testimonial.message}
                    <h4>{testimonial.name}</h4>
                  </div>
                </li>
              ))
            }
          </ul>
        </div>
      </div>
      <CtaBanner />
      <Footer />
    </div>
  );
}

Testimonials.propTypes = {
  page: PropTypes.object,
  widget: PropTypes.object,
};

Testimonials.defaultProps = {
  page: undefined,
  widget: {},
};

export default withData({
  page: 'testimonials',
  widget: 'testimonials',
}, {
  required: {
    page: true,
  },
})(Testimonials);



// WEBPACK FOOTER //
// ./src/pages/Testimonials/index.js